import { render, staticRenderFns } from "./ReportCommentAlertListIndex.vue?vue&type=template&id=5de46867&"
import script from "./ReportCommentAlertListIndex.vue?vue&type=script&lang=js&"
export * from "./ReportCommentAlertListIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports